import styled, { css } from 'styled-components'
import { device, fonts } from 'components/Variable'
import { rem } from 'utils/common'
import { merchantThemes } from 'components/Variable'

export const Title = styled.h2`
	text-transform: uppercase;
	font-weight: 600;
	text-align: center;
	margin-bottom: ${rem(30)};
	font-size: ${rem(20)};
	line-height: ${rem(25)};
	letter-spacing: ${rem(1.66667)};
	font-family: ${fonts.signika};
	color: ${({ theme }) => theme.color.blackOne};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
    
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
			text-transform: none;
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`
export const CustomRow = styled.div`
	margin: 0 ${rem(-32)};
	@media (${device.tablet}) {
		margin: 0 ${rem(-15)};
	}
`

export const EmailPopupContent = styled.div`
	padding: ${rem(35, 45)};
`
export const EmailPopupHeader = styled.div`
	border-radius: ${rem(8, 8, 0, 0)};
	position: relative;
	background: ${({ theme }) => theme.color.grayFive};
	text-align: center;
	padding: ${rem(10)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background: ${({ theme }) => theme.color.secondary};
			border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.primary};
		`}
`
export const EmailPopupTitle = styled.div`
	text-transform: uppercase;
	font-size: ${rem(18)};
	font-weight: 600;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			text-transform: none;
			font-size: ${rem(15)};
		`}
`
export const EmailPopupText = styled.div`
	text-align: center;
`

export const EmailPopupP = styled.p`
	margin: ${rem(5, 0)};
`

export const EmailPopupButton = styled.div`
	margin: ${rem(25)} auto 0 auto;
	text-align: center;
	max-width: 80%;
`
